export default {
    date: null,
    type_id: null,
    staffs: [],
    scheduleId: null,
    schedulePO: null,
    confirm_technician: false,
    confirm_client: false,
    rwt: null,
    site_count: 0,
    billing_account: 0,
    datesHours: [],
}
